module.exports = __webpack_public_path__ + "img/zipotle.dab98acd.png";